import Model from "./Model";
import {strict_join} from "../../_helpers/utils";

export default class Address extends Model {
    street1: string;
    street2: string;
    city: string;
    state: string;
    zip: string;
    latitude: number;
    longitude: number;

    completeAddress(): string {
        if(!this.street2 || this.street2=='undefined'){
            return strict_join([this.street1, this.city, this.state, this.zip], ', ');
        }
        return strict_join([this.street1, this.street2, this.city, this.state, this.zip], ', ');
    }
}


// WEBPACK FOOTER //
// ./app/client/_data/models/Address.ts